// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/fonts/SpoqaHanSansNeo-Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/fonts/SpoqaHanSansNeo-Bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/fonts/SpoqaHanSansNeo-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./assets/fonts/SpoqaHanSansNeo-Bold.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "SpoqaHanSansNeo";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('opentype');
  font-weight: 400;
}
@font-face {
  font-family: "SpoqaHanSansNeo";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('opentype');
  font-weight: 700;
}
@font-face {
  font-family: "SpoqaHanSansNeo";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype');
  font-weight: 400;
}
@font-face {
  font-family: "SpoqaHanSansNeo";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('truetype');
  font-weight: 700;
}

.App {
  height: 100%;
  /* pointer-events: none; */
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* router loading */
.loader {
  flex: 1 1;
  display: flex;
  position: absolute;
  z-index: 20;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: rgba(255, 255, 255, 0.7);
}
.spinner {
  width: 50px;
  height: 40px;
  text-align: center;
  font-size: 10px;
}

.spinner > div {
  border-radius: 2px;
  margin-right: 3px;
  background-color: #aaa;
  height: 100%;
  width: 6px;
  display: inline-block;
  animation: sk-stretchdelay 1.2s infinite ease-in-out;
}

.spinner .rect2 {
  animation-delay: -1.1s;
}

.spinner .rect3 {
  animation-delay: -1s;
}

.spinner .rect4 {
  animation-delay: -0.9s;
}

.spinner .rect5 {
  animation-delay: -0.8s;
}

@keyframes sk-stretchdelay {
  0%,
  40%,
  100% {
  transform: scaleY(0.4);
  -webkit-transform: scaleY(0.4);
  }
  20% {
  transform: scaleY(1);
  -webkit-transform: scaleY(1);
  }
}

.k-grid-header .k-header > .k-link {
	text-align: center;
}
.k-grid th, .k-grid td {
	text-align: center !important;
	cursor: pointer;
}
.paymentGrid .k-grid th, .k-grid td:not(.weekPayMoreBtn) {
  text-align: center !important;
	cursor: default;
}
.paymentGrid .k-grid th, .k-grid td.weekPayMoreBtn svg {
  transition: .3s;
}
.paymentGrid .k-grid td.weekPayMoreBtn:hover>svg {
  transform: translateX(10px);
  transition: .3s;
}
.weekPayMoreBtn svg {
  transition: .3s;
}
.weekPayMoreBtn:hover>svg {
  transform: translateX(10px);
  transition: .3s;
}

.k-grid * {
	/* font-family: 'NanumGothic', sans-serif ; */
	font-size: 13px;
}
.k-icon {
	font-size: 16px;
    font-family: "WebComponentsIcons";
}
.k-dateinput {
  padding-left: 0 !important;
}
.k-dateinput>input {
  height: 28px;
  border: 1px solid #ddd;
}
.k-grid-header .k-link>.k-column-title {
	flex: 1 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.k-grid * {
    font-family: 'SpoqaHanSansNeo', sans-serif !important;
}
.ag-header-cell-label {
    justify-content: center;
}

.emptyArea {
  margin-top: 10%;
  text-align: center;
}
.emptyText {
  color: #ccc;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,+DAAyE;EACzE,gBAAgB;AAClB;AACA;EACE,8BAA8B;EAC9B,+DAAsE;EACtE,gBAAgB;AAClB;AACA;EACE,8BAA8B;EAC9B,+DAAyE;EACzE,gBAAgB;AAClB;AACA;EACE,8BAA8B;EAC9B,+DAAsE;EACtE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,mBAAmB;AACnB;EACE,SAAO;EACP,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,OAAO;EACP,QAAQ;EACR,MAAM;EACN,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,0CAA0C;AAC5C;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,YAAY;EACZ,UAAU;EACV,qBAAqB;EAGrB,oDAAoD;AACtD;;AAEA;EAEE,sBAAsB;AACxB;;AAEA;EAEE,oBAAoB;AACtB;;AAEA;EAEE,sBAAsB;AACxB;;AAEA;EAEE,sBAAsB;AACxB;;AAaA;EACE;;;EAGA,sBAAsB;EACtB,8BAA8B;EAC9B;EACA;EACA,oBAAoB;EACpB,4BAA4B;EAC5B;AACF;;AAEA;CACC,kBAAkB;AACnB;AACA;CACC,6BAA6B;CAC7B,eAAe;AAChB;AACA;EACE,6BAA6B;CAC9B,eAAe;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,2BAA2B;EAC3B,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;CACC,6CAA6C;CAC7C,eAAe;AAChB;AACA;CACC,eAAe;IACZ,iCAAiC;AACrC;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,YAAY;EACZ,sBAAsB;AACxB;AACA;CACC,SAAO;EACN,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;IACI,qDAAqD;AACzD;AACA;IACI,uBAAuB;AAC3B;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,WAAW;AACb","sourcesContent":["@font-face {\n  font-family: \"SpoqaHanSansNeo\";\n  src: url('./assets/fonts/SpoqaHanSansNeo-Regular.otf') format('opentype');\n  font-weight: 400;\n}\n@font-face {\n  font-family: \"SpoqaHanSansNeo\";\n  src: url('./assets/fonts/SpoqaHanSansNeo-Bold.otf') format('opentype');\n  font-weight: 700;\n}\n@font-face {\n  font-family: \"SpoqaHanSansNeo\";\n  src: url('./assets/fonts/SpoqaHanSansNeo-Regular.ttf') format('truetype');\n  font-weight: 400;\n}\n@font-face {\n  font-family: \"SpoqaHanSansNeo\";\n  src: url('./assets/fonts/SpoqaHanSansNeo-Bold.ttf') format('truetype');\n  font-weight: 700;\n}\n\n.App {\n  height: 100%;\n  /* pointer-events: none; */\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* router loading */\n.loader {\n  flex: 1;\n  display: flex;\n  position: absolute;\n  z-index: 20;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  background-color: rgba(255, 255, 255, 0.7);\n}\n.spinner {\n  width: 50px;\n  height: 40px;\n  text-align: center;\n  font-size: 10px;\n}\n\n.spinner > div {\n  border-radius: 2px;\n  margin-right: 3px;\n  background-color: #aaa;\n  height: 100%;\n  width: 6px;\n  display: inline-block;\n\n  -webkit-animation: sk-stretchdelay 1.2s infinite ease-in-out;\n  animation: sk-stretchdelay 1.2s infinite ease-in-out;\n}\n\n.spinner .rect2 {\n  -webkit-animation-delay: -1.1s;\n  animation-delay: -1.1s;\n}\n\n.spinner .rect3 {\n  -webkit-animation-delay: -1s;\n  animation-delay: -1s;\n}\n\n.spinner .rect4 {\n  -webkit-animation-delay: -0.9s;\n  animation-delay: -0.9s;\n}\n\n.spinner .rect5 {\n  -webkit-animation-delay: -0.8s;\n  animation-delay: -0.8s;\n}\n\n@-webkit-keyframes sk-stretchdelay {\n  0%,\n  40%,\n  100% {\n  -webkit-transform: scaleY(0.4);\n  }\n  20% {\n  -webkit-transform: scaleY(1);\n  }\n}\n\n@keyframes sk-stretchdelay {\n  0%,\n  40%,\n  100% {\n  transform: scaleY(0.4);\n  -webkit-transform: scaleY(0.4);\n  }\n  20% {\n  transform: scaleY(1);\n  -webkit-transform: scaleY(1);\n  }\n}\n\n.k-grid-header .k-header > .k-link {\n\ttext-align: center;\n}\n.k-grid th, .k-grid td {\n\ttext-align: center !important;\n\tcursor: pointer;\n}\n.paymentGrid .k-grid th, .k-grid td:not(.weekPayMoreBtn) {\n  text-align: center !important;\n\tcursor: default;\n}\n.paymentGrid .k-grid th, .k-grid td.weekPayMoreBtn svg {\n  transition: .3s;\n}\n.paymentGrid .k-grid td.weekPayMoreBtn:hover>svg {\n  transform: translateX(10px);\n  transition: .3s;\n}\n.weekPayMoreBtn svg {\n  transition: .3s;\n}\n.weekPayMoreBtn:hover>svg {\n  transform: translateX(10px);\n  transition: .3s;\n}\n\n.k-grid * {\n\t/* font-family: 'NanumGothic', sans-serif ; */\n\tfont-size: 13px;\n}\n.k-icon {\n\tfont-size: 16px;\n    font-family: \"WebComponentsIcons\";\n}\n.k-dateinput {\n  padding-left: 0 !important;\n}\n.k-dateinput>input {\n  height: 28px;\n  border: 1px solid #ddd;\n}\n.k-grid-header .k-link>.k-column-title {\n\tflex: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.k-grid * {\n    font-family: 'SpoqaHanSansNeo', sans-serif !important;\n}\n.ag-header-cell-label {\n    justify-content: center;\n}\n\n.emptyArea {\n  margin-top: 10%;\n  text-align: center;\n}\n.emptyText {\n  color: #ccc;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
